export const GLOBAL_STATE = 'AssessmentFormative'

export const ASSESSMENT_FORMATIVE = 'ASSESSMENT_FORMATIVE' as const
export const ASSESSMENT_FORMATIVE_CREATE = 'ASSESSMENT_FORMATIVE_CREATE' as const
export const ASSESSMENT_FORMATIVE_LIST = 'ASSESSMENT_FORMATIVE_LIST' as const
